import { Link } from "react-router-dom";
import { Twitter, Linkedin } from "lucide-react";

const Footer = ({ className }: { className?: string }) => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (hash: string) => {
    const el = document.getElementById(hash.replace("#", ""));
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { hash: "#story", label: "My Story" },
    { hash: "#projects", label: "Projects" },
    { hash: "#case-studies", label: "Case Studies" },
    { hash: "#testimonials", label: "Testimonials" },
  ];

  const legalLinks = [
    { path: "/privacy-policy", label: "Privacy" },
    { path: "/terms-of-service", label: "Terms" },
  ];

  return (
    <footer className={`py-16 ${className || ""}`}>
      <div className="container">
        <div className="skeuo-card p-8 md:p-12" style={{ borderRadius: 32 }}>
          <div className="grid md:grid-cols-3 gap-10">
            {/* Brand */}
            <div>
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="font-heading text-xl font-bold text-text-primary tracking-tight mb-3 block"
              >
                Joel Bruce<span className="text-primary">.</span>
              </button>
              <p className="text-sm text-text-secondary leading-relaxed">
                Helping founders become their own best marketing channel.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-sm font-semibold text-text-primary mb-4">Navigate</h4>
              <nav className="flex flex-col gap-2">
                {navLinks.map((link) => (
                  <button
                    key={link.hash}
                    onClick={() => scrollToSection(link.hash)}
                    className="text-sm text-text-secondary hover:text-primary transition-colors duration-200 text-left"
                  >
                    {link.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Connect */}
            <div>
              <h4 className="text-sm font-semibold text-text-primary mb-4">Connect</h4>
              <a
                href="mailto:hello@joelbruce.com"
                className="text-sm text-text-secondary hover:text-primary transition-colors duration-200 block mb-3"
              >
                hello@joelbruce.com
              </a>
              <div className="flex items-center gap-3">
                <a
                  href="https://twitter.com/joelbruce"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-muted hover:text-primary transition-colors duration-200"
                >
                  <Twitter className="w-4 h-4" />
                </a>
                <a
                  href="https://linkedin.com/in/joelbruce"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-muted hover:text-primary transition-colors duration-200"
                >
                  <Linkedin className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          <div className="h-px bg-border my-8" />

          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-text-muted">
            <p>&copy; {currentYear} Joel Bruce. All rights reserved.</p>
            <div className="flex gap-6">
              {legalLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="hover:text-primary transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
